import { color } from '../../../../../resources';

export const homeTabContentviewStyle = {
  width: '100vw',
  height: '100%',
  backgroundColor: color.content_background,
  border: 'none',
  paddingBottom: '50px',
  overflowY: 'auto',
};
